import type { ConfigValueListQueryVariables } from '@schema/main';

export type ConfigValues = ConfigValueListQueryVariables & {
  cashback_for_pickup: string;
  courier_oferta: string;
};

export const configValues: ConfigValues = {
  invite_bonus_inviter: false, // Тот кто приглашает
  invite_bonus_invited: false, // Тот кто регается по приглашению
  api_yandex_key: false, // Ключ к API карт Яндекса
  dadata_api_key: false, // Ключ к API DaData
  install_mobile_app_title: false, // Заголовок установки приложения
  install_mobile_app_text: false, // Текст установки приложения
  invite_acl: false, // Статусы пользователей, которые могут делиться реф ссылкой
  qr_code_enable: false, // параметр отвечающий за отображение qrCode ссылки
  miadzaki_forever: false,
  tinkoff_auth_partner: false, // включена ли авторизация через тинька
  force_yandex_metrika: false, // '1' — принудительно включить Яндекс.Метрику (в сторе → boolean)

  // дефолтные значения для выставления интервалов
  default_delivery_morning_start: false,
  default_delivery_morning_end: false,
  default_delivery_evening_start: false,
  default_delivery_evening_end: false,
  cashback_for_pickup: '0',
  courier_oferta: ''
};

export type ConfigValuesKey = keyof typeof configValues;

export const configValuesKeys: ConfigValuesKey[] = Object.keys(
  configValues
).map(item => item as ConfigValuesKey);
